<template>
  <div class="auth-wrapper">
    <div class="sufee-login d-flex align-content-center flex-wrap">
      <div class="container">
        <div class="login-content">
          <br>
          <!--div class="login-logo">
            <a href="index.html">
              <img class="align-content" src="img/logo.png" alt style="height: 80px;">
            </a-->
          <div class="login-form">
            <router-view/>
          </div>
          <!--Version/-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Version from "@/components/globals/Version.vue";

export default {
  components: {
    //Version
  },
  created() {
    $("body").addClass("auth-wrapper");
    $("body").removeClass("menu-side-left");
    $("body").removeClass("menu-position-side");
    $("body").removeClass("full-screen");
  },
  mounted() {
  },
  
};

</script>
